/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module HealthMonitorModule
 */

import { HealthMonitorLdap } from 'object-types';

import {
    IHealthMonitorLdap,
    IHealthMonitorSSLAttributes,
} from 'generated-types';

import { MessageItem } from 'ajs/modules/data-model/factories/message-item.factory';

/**
 * Ldap health monitor type without the ssl_aatributes.
 */
type THealthMonitorLdapPartial = Omit<IHealthMonitorLdap, 'ssl_attributes'>;

/**
 * LDAP Health Monitor Config type.
 */
interface IHealthMonitorLDAPConfig extends THealthMonitorLdapPartial {
    ssl_attributes: MessageItem<IHealthMonitorSSLAttributes>;
}

/**
 * @description Health Monitor LDAP Config Item.
 * @author Sarthak Kapoor
 */
export class HealthMonitorLdapConfigItem extends MessageItem<IHealthMonitorLDAPConfig> {
    constructor(args = {}) {
        const extendedArgs = {
            objectType: HealthMonitorLdap,
            ...args,
        };

        super(extendedArgs);
    }

    /** @override */
    protected requiredFields(): string[] {
        return ['ssl_attributes'];
    }
}
